<template>
  <li
    class="dui-expandable-option"
    :class="{ 'expanded': option.expanded,
              'has-options': (option.options && option.options.length),
              'no-options': !(option.options && option.options.length),
              'selected': option.selected }"
  >
    <a
      v-if="(option.options && option.options.length)"
      class="expand-toggle"
      :href="option.href"
      title="Expand/collapse"
      @click="toggleExpanded"
    >
      <svg
        width="8px"
        height="10px"
        viewBox="0 0 8 9.1"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:bx="https://boxy-svg.com"
      >
        <g
          id="triangle-container"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
          transform="matrix(0, -1, 1, 0, 0, 9.042801)"
          bx:origin="0.941278 -0.061198"
        >
          <g
            id="triangle"
            transform="translate(-161.000000, -455.000000)"
            fill="#2A2A2A"
            fill-rule="nonzero"
          >
            <path
              id="Triangle-Copy"
              d="M166.6992,455.65939 L169.841899,460.877731 C170.240798,461.540087 170.027223,462.400404 169.364866,462.799303 C169.146829,462.930613 168.897121,463 168.642597,463 L162.357198,463 C161.584,463 160.957198,462.373199 160.957198,461.6 C160.957198,461.345476 161.026585,461.095767 161.157896,460.877731 L164.300595,455.65939 C164.699493,454.997033 165.55981,454.783458 166.222167,455.182356 C166.417685,455.300106 166.581451,455.463871 166.6992,455.65939 Z"
              transform="translate(165.500000, 459.000000) rotate(180.000000) translate(-165.500000, -459.000000) "
            />
          </g>
        </g>
      </svg>
    </a>

    <a
      class="option-text"
      :href="option.href"
      :title="option.text"
      @click="selectOption"
    >
      <span>{{ option.text }}</span>
    </a>

    <ul v-if="option.options">
      <DuiExpandableOption
        v-for="(innerOption, index) in option.options"
        :key="index"
        :option="innerOption"
        @option-selected="innerOptionSelected"
      />
    </ul>
  </li>
</template>

<script>
export default {
  name: 'DuiExpandableOption',
  props: {
    option: {
      type: Object,
      required: true,
    },
  },
  methods: {
    innerOptionSelected(innerOption) {
      this.$emit('option-selected', innerOption);
    },

    selectOption(ev) {
      ev.preventDefault();
      this.$emit('option-selected', this.option);
    },

    toggleExpanded(ev) {
      ev.preventDefault();
      this.$set(this.option, 'expanded', !this.option.expanded);
    },
  },
};
</script>
